__turbopack_context__.v({
  "closeButton": "ErrorNotifications-module-scss-module__R3VDzG__closeButton",
  "notification": "ErrorNotifications-module-scss-module__R3VDzG__notification",
  "notificationEnter": "ErrorNotifications-module-scss-module__R3VDzG__notificationEnter",
  "notificationEnterActive": "ErrorNotifications-module-scss-module__R3VDzG__notificationEnterActive",
  "notificationExit": "ErrorNotifications-module-scss-module__R3VDzG__notificationExit",
  "notificationExitActive": "ErrorNotifications-module-scss-module__R3VDzG__notificationExitActive",
  "success": "ErrorNotifications-module-scss-module__R3VDzG__success",
  "wrapper": "ErrorNotifications-module-scss-module__R3VDzG__wrapper",
});
